import {Component, Input, OnInit} from '@angular/core';
import {DynamicDialogConfig} from "primeng/dynamicdialog";

@Component({
  selector: 'app-detalle-tasa-condicion',
  templateUrl: './detalle-tasa-condicion.component.html',
  styleUrls: ['./detalle-tasa-condicion.component.css']
})
export class DetalleTasaCondicionComponent implements OnInit {

  @Input() registro: any;
  constructor(private config: DynamicDialogConfig) { }

  ngOnInit() {
    this.registro = this.config.data.registro;
  }

}
